'use strict';

angular.module('internal.inspections', ['ngAnimate', 'ui.bootstrap'])
    .config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
        $stateProvider
            // internal routings
            // inspections tab
            .state('internal.inspecting.inspections', {
                url: '/inspections',
                templateUrl: paths.app + 'inspections/components/inspections/inspections.html',
                controller: 'InternalInspections',
                resolve: {
                    permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        return Permissions.view(this.self.name).then(function (access) {
                            if (!access) {
                                $state.go('internal.inspecting.denied');
                            }
                        });
                    }]
                }
            })
            .state('internal.inspecting.visit', {
                url: '/visit/:id',
                templateUrl: 'templates/inspection-visit/inspection-visit.html',
                controller: 'InspectionVisit',
                params: {
                    id: null,
                    visit: null
                },
                resolve: {
                    permission: ['$state', '$stateParams', '$rootScope', 'Permissions', function ($state, $stateParams, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;

                        var method = 'view';
                        if ($stateParams.id == null) {
                            method = 'add';
                        }

                        return Permissions[method]('internal.inspecting.inspections').then(function (access) {
                            if (!access) {
                                $state.go('internal.inspecting.denied');
                            }
                        });
                    }]
                }
            })
            .state('internal.inspecting.inspection', {
                abstract: true,
                templateUrl: paths.app + 'inspections/components/inspection/inspection.html',
                controller: 'InternalInspection',
                params: {
                    id: null,
                    inspection: null
                }
            })
                .state('internal.inspecting.inspection.details', {
                    url: '/inspection/:id',
                    templateUrl: paths.app + 'inspections/components/inspection-details/inspection-details.html',
                    controller: 'InternalInspectionDetails',
                    params: {
                        id: null,
                        inspection: null
                    },
                    resolve: {
                        permission: ['$state', '$stateParams', '$rootScope', 'Permissions', function ($state, $stateParams, $rootScope, Permissions) {
                            $rootScope.$state.current = this.self;

                            var method = 'view';
                            if ($stateParams.id == null) {
                                method = 'add';
                            }

                            return Permissions[method]('internal.inspecting.inspections').then(function (access) {
                                if (!access) {
                                    $state.go('internal.inspecting.denied');
                                }
                            });
                        }]
                    }
                })
                .state('internal.inspecting.inspection.checklist', {
                    url: '/inspection/:id/checklist/:checklistID',
                    templateUrl: paths.app + 'inspections/components/inspection-checklist/inspection-checklist.html',
                    controller: 'InternalInspectionChecklist',
                    params: {
                        id: null,
                        inspection: null,
                        checklistID: null,
                        checklist: null
                    },
                    resolve: {
                        permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                            $rootScope.$state.current = this.self;
                            return Permissions.view('internal.inspecting.inspections').then(function (access) {
                                if (!access) {
                                    $state.go('internal.inspecting.denied');
                                }
                            });
                        }]
                    }
                })
                .state('internal.inspecting.inspection.comment', {
                    url: '/inspection/:id/comment',
                    templateUrl: paths.app + 'inspections/components/inspection-react/inspection-react.html',
                    controller: 'InternalInspectionReact',
                    params: {
                        id: null
                    },
                    resolve: {
                        permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                            $rootScope.$state.current = this.self;
                            return Permissions.view('internal.inspecting.inspections').then(function (access) {
                                if (!access) {
                                    $state.go('internal.inspecting.denied');
                                }
                            });
                        }]
                    }
                })
                .state('internal.inspecting.inspection.commentDetails', {
                    url: '/inspection/:id/comment/:commentId',
                    templateUrl: paths.app + 'inspections/components/inspection-react/inspection-react.html',
                    controller: 'InternalInspectionReact',
                    params: {
                        id: null,
                        commentId: null
                    },
                    resolve: {
                        permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                            $rootScope.$state.current = this.self;
                            return Permissions.view('internal.inspecting.inspections').then(function (access) {
                                if (!access) {
                                    $state.go('internal.inspecting.denied');
                                }
                            });
                        }]
                    }
                })
                .state('internal.inspecting.inspection.outcome', {
                    url: '/inspection/:id/outcome',
                    templateUrl: paths.app + 'inspections/components/inspection-outcome/inspection-outcome.html',
                    controller: 'InternalInspectionOutcome',
                    params: {
                        id: null,
                        inspection: null
                    },
                    resolve: {
                        permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                            $rootScope.$state.current = this.self;
                            return Permissions.view('internal.inspecting.inspections').then(function (access) {
                                if (!access) {
                                    $state.go('internal.inspecting.denied');
                                }
                            });
                        }]
                    }
                })
                .state('internal.inspecting.inspection.related', {
                    url: '/inspection/:id/related/:serviceID',
                    templateUrl: paths.app + 'inspections/components/inspection-related/inspection-related.html',
                    controller: 'InternalInspectionRelated',
                    params: {
                        id: null,
                        inspection: null,
                        serviceID: null
                    },
                    resolve: {
                        permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                            $rootScope.$state.current = this.self;
                            return Permissions.view('internal.inspecting.inspections').then(function (access) {
                                if (!access) {
                                    $state.go('internal.inspecting.denied');
                                }
                            });
                        }]
                    }
                })
                .state('internal.inspecting.inspection.alerts', {
                    url: '/inspection/:id/alerts',
                    templateUrl: paths.app + 'inspections/components/inspection-alerts/inspection-alerts.html',
                    controller: 'InternalInspectionAlerts',
                    params: {
                        id: null,
                        inspection: null
                    },
                    resolve: {
                        permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                            $rootScope.$state.current = this.self;
                            return Permissions.view('internal.inspecting.inspections').then(function (access) {
                                if (!access) {
                                    $state.go('internal.inspecting.denied');
                                }
                            });
                        }]
                    }
                })
                .state('internal.inspecting.inspection.alert', {
                    url: '/inspection/:id/alert/:inspectionAlertID',
                    templateUrl: paths.app + 'inspections/components/inspection-alert/inspection-alert.html',
                    controller: 'InternalInspectionAlert',
                    params: {
                        id: null,
                        inspection: null,
                        inspectionAlertID: null,
                        inspection_alert: null
                    },
                    resolve: {
                        permission: ['$state', '$stateParams', '$rootScope', 'Permissions', function ($state, $stateParams, $rootScope, Permissions) {
                            $rootScope.$state.current = this.self;

                            var method = 'view';
                            if ($stateParams.inspectionAlertID == null) {
                                method = 'add';
                            }

                            return Permissions[method]('internal.inspecting.inspections').then(function (access) {
                                if (!access) {
                                    $state.go('internal.inspecting.denied');
                                }
                            });
                        }]
                    }
                })
                .state('internal.inspecting.inspection.correspondences', {
                    url: '/inspection/:id/correspondences',
                    templateUrl: paths.app + 'inspections/components/inspection-correspondences/inspection-correspondences.html',
                    controller: 'InternalInspectionCorrespondences',
                    params: {
                        id: null,
                        inspection: null
                    },
                    resolve: {
                        permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                            $rootScope.$state.current = this.self;
                            return Permissions.view('internal.inspecting.inspections').then(function (access) {
                                if (!access) {
                                    $state.go('internal.inspecting.denied');
                                }
                            });
                        }]
                    }
                })
                .state('internal.inspecting.inspection.correspondence', {
                    url: '/inspection/:id/correspondence/:inspectionCorrespondenceID',
                    templateUrl: paths.app + 'inspections/components/inspection-correspondence/inspection-correspondence.html',
                    controller: 'InternalInspectionCorrespondence',
                    params: {
                        id: null,
                        inspection: null,
                        inspectionCorrespondenceID: null,
                        inspection_correspondence: null
                    },
                    resolve: {
                        permission: ['$state', '$stateParams', '$rootScope', 'Permissions', function ($state, $stateParams, $rootScope, Permissions) {
                            $rootScope.$state.current = this.self;

                            var method = 'view';
                            if ($stateParams.inspectionCorrespondenceID == null) {
                                method = 'add';
                            }

                            return Permissions[method]('internal.inspecting.inspections').then(function (access) {
                                if (!access) {
                                    $state.go('internal.inspecting.denied');
                                }
                            });
                        }]
                    }
                })
                .state('internal.inspecting.inspection.documents', {
                    url: '/inspection/:id/documents',
                    templateUrl: paths.app + 'inspections/components/inspection-documents/inspection-documents.html',
                    controller: 'InternalInspectionDocuments',
                    params: {
                        id: null,
                        inspection: null
                    },
                    resolve: {
                        permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                            $rootScope.$state.current = this.self;
                            return Permissions.view('internal.inspecting.inspections').then(function (access) {
                                if (!access) {
                                    $state.go('internal.inspecting.denied');
                                }
                            });
                        }]
                    }
                })
                .state('internal.inspecting.inspection.document', {
                    url: '/inspection/:id/document/:inspectionDocumentID',
                    templateUrl: paths.app + 'inspections/components/inspection-document/inspection-document.html',
                    controller: 'InternalInspectionDocument',
                    params: {
                        id: null,
                        inspection: null,
                        inspectionDocumentID: null,
                        inspection_document: null
                    },
                    resolve: {
                        permission: ['$state', '$stateParams', '$rootScope', 'Permissions', function ($state, $stateParams, $rootScope, Permissions) {
                            $rootScope.$state.current = this.self;

                            var method = 'view';
                            if ($stateParams.inspectionDocumentID == null) {
                                method = 'add';
                            }

                            return Permissions[method]('internal.inspecting.inspections').then(function (access) {
                                if (!access) {
                                    $state.go('internal.inspecting.denied');
                                }
                            });
                        }]
                    }
                })
                .state('internal.inspecting.inspection.notes', {
                    url: '/inspection/:id/notes',
                    templateUrl: paths.app + 'inspections/components/inspection-notes/inspection-notes.html',
                    controller: 'InternalInspectionNotes',
                    params: {
                        id: null,
                        inspection: null
                    },
                    resolve: {
                        permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                            $rootScope.$state.current = this.self;
                            return Permissions.view('internal.inspecting.inspections').then(function (access) {
                                if (!access) {
                                    $state.go('internal.inspecting.denied');
                                }
                            });
                        }]
                    }
                })
                .state('internal.inspecting.inspection.note', {
                    url: '/inspection/:id/note/:inspectionNoteID',
                    templateUrl: paths.app + 'inspections/components/inspection-note/inspection-note.html',
                    controller: 'InternalInspectionNote',
                    params: {
                        id: null,
                        inspection: null,
                        inspectionNoteID: null,
                        inspection_note: null
                    },
                    resolve: {
                        permission: ['$state', '$stateParams', '$rootScope', 'Permissions', function ($state, $stateParams, $rootScope, Permissions) {
                            $rootScope.$state.current = this.self;

                            var method = 'view';
                            if ($stateParams.inspectionNoteID == null) {
                                method = 'add';
                            }

                            return Permissions[method]('internal.inspecting.inspections').then(function (access) {
                                if (!access) {
                                    $state.go('internal.inspecting.denied');
                                }
                            });
                        }]
                    }
                })
                .state('internal.inspecting.inspection.fee', {
                    url: '/inspection/:id/outcome/fee/:inspectionFeeID',
                    templateUrl: paths.app + 'inspections/components/inspection-fee/inspection-fee.html',
                    controller: 'InternalInspectionFee',
                    params: {
                        id: null,
                        inspection: null,
                        inspectionFeeID: null
                    },
                    resolve: {
                        permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                            $rootScope.$state.current = this.self;
                            return Permissions.view('internal.inspecting.inspections').then(function (access) {
                                if (!access) {
                                    $state.go('internal.inspecting.denied');
                                }
                            });
                        }]
                    }
                })
            // scheduling tab
            .state('internal.inspecting.scheduling', {
                url: '/scheduling',
                templateUrl: 'templates/inspections-scheduling/inspections-scheduling.html',
                controller: 'InspectionsScheduling',
                resolve: {
                    permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        return Permissions.view(this.self.name).then(function (access) {
                            if (!access) {
                                $state.go('internal.inspecting.denied');
                            }
                        });
                    }]
                }
            })
            .state('internal.inspecting.schedule', {
                url: '/schedule',
                templateUrl: 'templates/inspections-schedule/inspections-schedule.html',
                controller: 'InspectionsSchedule',
                resolve: {
                    permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        return Permissions.view('internal.inspecting.scheduling').then(function (access) {
                            if (!access) {
                                $state.go('internal.inspecting.denied');
                            }
                        });
                    }]
                }
            })
            // resource tab
            .state('internal.inspecting.resource', {
                abstract: true,
                templateUrl: paths.app + 'inspections/layouts/resource.html'
            })
                .state('internal.inspecting.resource.checklists', {
                    url: '/inspections/checklists',
                    templateUrl: paths.app + 'inspections/components/checklists/checklists.html',
                    controller: 'InternalInspectionsChecklists',
                    resolve: {
                        permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                            $rootScope.$state.current = this.self;
                            return Permissions.view('internal.inspecting.resource').then(function (access) {
                                if (!access) {
                                    $state.go('internal.inspecting.denied');
                                }
                            });
                        }]
                    }
                })
                .state('internal.inspecting.resource.checklist', {
                    abstract: true,
                    templateUrl: paths.app + 'inspections/components/checklist/checklist.html',
                    controller: 'InternalInspectionsChecklist',
                    params: {
                        id: null,
                        checklist: null
                    }
                })
                    .state('internal.inspecting.resource.checklist.layout', {
                        url: '/inspections/checklist/:id',
                        templateUrl: paths.app + 'inspections/components/checklist-layout/checklist-layout.html',
                        controller: 'InternalInspectionsChecklistLayout',
                        params: {
                            id: null,
                            checklist: null
                        },
                        resolve: {
                            permission: ['$state', '$stateParams', '$rootScope', 'Permissions', function ($state, $stateParams, $rootScope, Permissions) {
                                $rootScope.$state.current = this.self;

                                var method = 'view';
                                if ($stateParams.id == null) {
                                    method = 'add';
                                }

                                return Permissions[method]('internal.inspecting.resource').then(function (access) {
                                    if (!access) {
                                        $state.go('internal.inspecting.denied');
                                    }
                                });
                            }]
                        }
                    })
                    .state('internal.inspecting.resource.checklist.form', {
                        url: '/inspections/checklist/:id/form/:formID',
                        templateUrl: paths.app + 'inspections/components/checklist-form/checklist-form.html',
                        controller: 'InternalInspectionsChecklistForm',
                        params: {
                            id: null,
                            checklist: null,
                            formID: null,
                            form: null
                        },
                        resolve: {
                            permission: ['$state', '$stateParams', '$rootScope', 'Permissions', function ($state, $stateParams, $rootScope, Permissions) {
                                $rootScope.$state.current = this.self;
                                return Permissions.view('internal.inspecting.resource').then(function (access) {
                                    if (!access) {
                                        $state.go('internal.inspecting.denied');
                                    }
                                });
                            }]
                        }
                    })
                    .state('internal.inspecting.resource.checklist.preview', {
                        url: '/inspections/checklist/:id/preview/:formID',
                        templateUrl: paths.app + 'inspections/components/checklist-preview/checklist-preview.html',
                        controller: 'InternalInspectionsChecklistPreview',
                        params: {
                            id: null,
                            checklist: null,
                            formID: null,
                            form: null
                        },
                        resolve: {
                            permission: ['$state', '$stateParams', '$rootScope', 'Permissions', function ($state, $stateParams, $rootScope, Permissions) {
                                $rootScope.$state.current = this.self;
                                return Permissions.view('internal.inspecting.resource').then(function (access) {
                                    if (!access) {
                                        $state.go('internal.inspecting.denied');
                                    }
                                });
                            }]
                        }
                    })
                .state('internal.inspecting.resource.statuses', {
                    url: '/inspections/statuses',
                    templateUrl: paths.app + 'inspections/components/statuses/statuses.html',
                    controller: 'InternalInspectionsStatuses',
                    resolve: {
                        permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                            $rootScope.$state.current = this.self;
                            return Permissions.view('internal.inspecting.resource').then(function (access) {
                                if (!access) {
                                    $state.go('internal.inspecting.denied');
                                }
                            });
                        }]
                    }
                })
                .state('internal.inspecting.resource.status', {
                    url: '/inspections/status/:id',
                    templateUrl: paths.app + 'inspections/components/status/status.html',
                    controller: 'InternalInspectionsStatus',
                    params: {
                        id: null,
                        status: null
                    },
                    resolve: {
                        permission: ['$state', '$stateParams', '$rootScope', 'Permissions', function ($state, $stateParams, $rootScope, Permissions) {
                            $rootScope.$state.current = this.self;

                            var method = 'view';
                            if ($stateParams.id == null) {
                                method = 'add';
                            }

                            return Permissions[method]('internal.inspecting.resource').then(function (access) {
                                if (!access) {
                                    $state.go('internal.inspecting.denied');
                                }
                            });
                        }]
                    }
                })
                .state('internal.inspecting.resource.inspectors', {
                    url: '/inspections/inspectors',
                    templateUrl: paths.app + 'inspections/components/inspectors/inspectors.html',
                    controller: 'InternalInspectionsInspectors',
                    resolve: {
                        permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                            $rootScope.$state.current = this.self;
                            return Permissions.view('internal.inspecting.resource').then(function (access) {
                                if (!access) {
                                    $state.go('internal.inspecting.denied');
                                }
                            });
                        }]
                    }
                })
                .state('internal.inspecting.resource.deficiencies', {
                    url: '/inspections/deficiencies',
                    templateUrl: paths.app + 'inspections/components/deficiencies/deficiencies.html',
                    controller: 'InternalInspectionsDeficiencies',
                    resolve: {
                        permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                            $rootScope.$state.current = this.self;
                            return Permissions.view('internal.inspecting.resource').then(function (access) {
                                if (!access) {
                                    $state.go('internal.inspecting.denied');
                                }
                            });
                        }]
                    }
                })
                .state('internal.inspecting.resource.deficiency', {
                    url: '/inspections/deficiency/:id',
                    templateUrl: paths.app + 'inspections/components/deficiency/deficiency.html',
                    controller: 'InternalInspectionsDeficiency',
                    params: {
                        id: null,
                        deficiency: null
                    },
                    resolve: {
                        permission: ['$state', '$stateParams', '$rootScope', 'Permissions', function ($state, $stateParams, $rootScope, Permissions) {
                            $rootScope.$state.current = this.self;

                            var method = 'view';
                            if ($stateParams.id == null) {
                                method = 'add';
                            }

                            return Permissions[method]('internal.inspecting.resource').then(function (access) {
                                if (!access) {
                                    $state.go('internal.inspecting.denied');
                                }
                            });
                        }]
                    }
                })
                .state('internal.inspecting.resource.autonumber', {
                    url: '/inspections/autonumber',
                    templateUrl: paths.app + 'inspections/components/auto-number/auto-number.html',
                    controller: 'InternalInspectionsAutoNumber',
                    resolve: {
                        permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                            $rootScope.$state.current = this.self;
                            return Permissions.view('internal.inspecting.resource').then(function (access) {
                                if (!access) {
                                    $state.go('internal.inspecting.denied');
                                }
                            });
                        }]
                    }
                })
                .state('internal.inspecting.resource.triggers', {
                    url: '/inspections/triggers',
                    templateUrl: paths.app + 'inspections/components/triggers/triggers.html',
                    controller: 'InternalInspectionsTriggers',
                    resolve: {
                        permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                            $rootScope.$state.current = this.self;
                            return Permissions.view('internal.inspecting.resource').then(function (access) {
                                if (!access) {
                                    $state.go('internal.inspecting.denied');
                                }
                            });
                        }]
                    }
                })
                .state('internal.inspecting.resource.trigger', {
                    url: '/inspections/trigger/:id/:triggerObjectID',
                    templateUrl: paths.app + 'inspections/components/trigger/trigger.html',
                    controller: 'InternalInspectionsTrigger',
                    params: {
                        id: null,
                        triggerObjectID: null,
                        trigger: null
                    },
                    resolve: {
                        permission: ['$state', '$stateParams', '$rootScope', 'Permissions', function ($state, $stateParams, $rootScope, Permissions) {
                            $rootScope.$state.current = this.self;
                            return Permissions.view('internal.inspecting.resource').then(function (access) {
                                if (!access) {
                                    $state.go('internal.inspecting.denied');
                                }
                            });
                        }]
                    }
                })
    }])
;